module.exports = __webpack_public_path__ + "img/accueil-mariage-thumbnail.11d90b83.jpg";